import React from "react";
import styled from "styled-components";
import {
  Card, Row, Container, CardHeader
} from "reactstrap";

import { Title } from "../../components/StyledComponents";

import StepFlow from "./StepFlow";
import {
  put,
  endpoints,
} from "../../utils/axios";

const CardContainer = styled(Card)`
  width: 100%;
`;

export const Process = ({
  processId,
  process,
}) => {
  const handlePauseResume = ({ id: stepId, paused }) => {
    if (paused) {
      const url = endpoints.steps.resume(processId, stepId);
      put(url);
    } else {
      const url = endpoints.steps.pause(processId, stepId);
      put(url);
    }
  };

  const handleAbort = ({ id: stepId }) => {
    const url = endpoints.steps.abort(processId, stepId);
    put(url);
  };
  return (
    <Container fluid>
      <Row>
        <CardContainer>
          <CardHeader
            sx={{
              padding: "5px",
            }}
          >
            <Title>{process.name}</Title>
          </CardHeader>
          <StepFlow
            steps={process.steps}
            onPauseResume={(step) => handlePauseResume(step)}
            onAbort={(step) => handleAbort(step)}
          />
        </CardContainer>
      </Row>
    </Container>
  );
};
